@if (kingService.game()?.status === 'part_waiting' && kingService.timer() !==
-1) {
<div class="timer-title">{{ kingService.timer() }} Seconds Left</div>
<app-level-bar
  class="timer-bar"
  [current]="kingService.timer()"
  [total]="kingService.maxTimer"
/>

} @else {
<div class="timer-placeholder">Join to begin the battle</div>
}
